<template>
  <v-radio-group class="radio-group"
                 :value="value"
                 row
                 :disabled="disabled"
                 @change="onChange($event)">

    <div v-for="option in options"
         :key="option.value">

      <div :class="$style.radioWrapper">
        <v-radio color="#2C4F7A"
                 label=""
                 :value="option.value">
        </v-radio>

        <span :class="$style.radioLabel">

        <p :class="$style.radioLabelText"
           @click="onLabelClick(option.value)">
          {{ option.label }}
        </p>
        <app-tooltip v-if="option.tooltip">
          <template v-slot:tooltipHeader>
            {{ option.tooltipHeader }}
          </template>
          <template v-slot:tooltipText>
            {{ option.tooltipText }}
          </template>
        </app-tooltip>
      </span>
      </div>

      <span v-if="option.labelInfo"
            :class="$style.labelText">
        {{ option.labelInfo }}
      </span>

    </div>

  </v-radio-group>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    value: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e);
    },
    onLabelClick(e) {
      this.$emit('input', e);
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.radioWrapper {
  display: flex;
}

.radioLabel {
  position: relative;
  flex-grow: 1;
}

.radioLabelText {
  display: inline;
  cursor: pointer;
}

.tooltip {
  white-space: normal;
}

.labelText {
  display: block;
  margin-top: 4px;
  padding-left: 30px;
  font-family: $main-font;
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-style: italic;
  color: $main-text-color;
}

</style>

<style lang="scss">

.radio-group.v-input--radio-group.v-input--radio-group--row {
   .v-radio{
    margin-right: 0;
  }
}

</style>
